/**
 * Globalni helper za toast/modal poruke.
 * Inicijalizuje se kroz UiProvider koji zove installUiGlobals().
 * Koristi se iz logic fajlova umesto window.alert / window.confirm.
 */

type ToastType = "info" | "success" | "error" | "warning";

interface UiApi {
  showToast: (message: string, type?: ToastType) => void;
  confirm: (message: string) => Promise<boolean>;
  alert: (message: string) => void;
}

let uiInstance: UiApi | null = null;

export const installUiGlobals = (api: UiApi) => {
  uiInstance = api;
};

export const ui = {
  toast: (message: string, type: ToastType = "info") => {
    if (uiInstance) {
      uiInstance.showToast(message, type);
    } else {
      console.warn("UI not initialized, falling back to alert:", message);
      window.alert(message);
    }
  },
  alert: (message: string) => {
    if (uiInstance) {
      uiInstance.alert(message);
    } else {
      window.alert(message);
    }
  },
  confirm: async (message: string): Promise<boolean> => {
    if (uiInstance) {
      return uiInstance.confirm(message);
    }
    return window.confirm(message);
  },
};
